<template>
    <md-card class="players">
        <md-card-header>
            <div class="md-title">Players</div>
        </md-card-header>
        <md-card-content>
            <div>
                <div class="md-primary">Blue</div>
                <ul id="blue">
                    <li>Stephen</li>
                </ul>
            </div>
            <div>
                <div class="md-accent">Red</div>
                <ul id="red">
                    <li>stephens' alter ego</li>
                </ul>
            </div>
        </md-card-content>
    </md-card>
</template>

<script>

export default {
  name: 'Players',
  props: {
    players: Array
  },
   data: () => ({
    teams: {
      red: [],
      blue: []
    }
  }),
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.players {
        width:15rem;

}
</style>